import { render } from "./Reply_Inquiry.vue?vue&type=template&id=62db64fa&scoped=true"
import script from "./Reply_Inquiry.vue?vue&type=script&lang=js"
export * from "./Reply_Inquiry.vue?vue&type=script&lang=js"

import "./Reply_Inquiry.vue?vue&type=style&index=0&id=62db64fa&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62db64fa"]])

export default __exports__